import { Controller } from '@hotwired/stimulus';

export default class NoParticularOrderTestController extends Controller {
  static values = {
    answers:  Array,
    tabIndex: Number
  };

  static targets = [
    'choiceCheckbox',
    'answerLabel'
  ];

  answersValueChanged(answers) {
    if (answers.length === 0) {
      this.answerLabelTarget.textContent = '選択してください';

      this.dispatch('clearAnswer', {
        detail: {
          tabIndex: this.tabIndexValue
        }
      });
    } else {
      this.answerLabelTarget.textContent = answers.join(' ');

      this.dispatch('completeAnswer', {
        detail: {
          answer:   answers.join('/'),
          tabIndex: this.tabIndexValue
        }
      });
    }
  }

  toggleAnswer(e) {
    const { checked, value } = e.target;

    if (checked) {
      this.answersValue = [...this.answersValue, value].toSorted();
    } else {
      this.answersValue = this.answersValue.filter((answer) => answer !== value).toSorted();
    }
  }

  disableControls() {
    for (const el of this.choiceCheckboxTargets) {
      el.disabled = true;
    }
  }
}
